<template>
    <div>
        <b-card no-body>
            <b-card-body class="px-2 pt-2 pb-0">
                <b-row>
                    <b-col xl="4" lg="4" md="6" sm="12" class="text-left mb-1">
                        <b-form-group label-for="filterInput" class="mb-0">
                            <b-button variant="gradient-primary" size="sm" class="mr-1" @click="traerData"
                                :disabled="loading" v-b-tooltip.hover.top="'Recargar Datos'">
                                <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading" />
                            </b-button>
                            <b-button v-if="$can('create', 'Shipping Advice')" variant="gradient-primary" size="sm"
                                class="mr-1" v-b-modal.modal-crear v-b-tooltip.hover.top="'Crear Registro'">
                                <font-awesome-icon icon="fa-solid fa-plus" />
                            </b-button>
                            <b-button v-if="$can('create', 'Shipping Advice')" @click="mostrarModalVaciar()"
                                variant="gradient-primary" size="sm" class="mr-1"
                                v-b-tooltip.hover.top="'Vaciar Registros'">
                                <feather-icon icon="TrashIcon" size="15" />
                            </b-button>

                        </b-form-group>
                    </b-col>
                    <b-col xl="4" lg="4" md="6" sm="12" class="text-center mb-1 font-medium-1 text-bold font-weight-bold">

                    </b-col>
                    <b-col xl="4" lg="4" md="6" sm="12" class="text-right mb-1">
                        <div class="d-flex align-items-center justify-content-end">
                            <b-button variant="gradient-primary" @click="sendMails()" size="sm" class="mr-1"
                                v-b-tooltip.hover.top="'Enviar correos'"
                                style="background-image: linear-gradient(47deg, #6737ba, #8857cd);">
                                <font-awesome-icon icon="fa-solid fa-upload" />
                            </b-button>
                            <b-input-group size="sm">
                                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Buscar" />
                                <b-input-group-append>
                                    <b-button :disabled="!filter" @click="filter = ''">
                                        Borrar
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                    </b-col>
                </b-row>
            </b-card-body>

            <b-table hover responsive small sticky-header="58vh" class="position-relative" :items="items" :fields="fields"
                :filter="filter" :filter-included-fields="filterOn" :busy="loading" show-empty
                empty-text="No se encontraron datos en esta tabla."
                emptyFilteredText="No se encontraron datos con los parámetros ingresados.">
                <template #table-busy>
                    <div class="text-center text-dark my-1">
                        <b-spinner class="align-middle"></b-spinner> &emsp;
                        <strong>Obteniendo datos...</strong>
                    </div>
                </template>

                <template #cell(editar)="row">
                    <div class="text-nowrap">
                        <feather-icon v-if="$can('create', 'Shipping Advice')" :id="`btn_${row.item.id}_editare`"
                            icon="EditIcon" size="16" class="ml-1" @click="mostrarModalEditar(row.item)"
                            v-b-tooltip.hover.top="'Editar Registro'" />
                        <feather-icon v-if="$can('create', 'Shipping Advice')" :id="`btn_${row.item.id}_eliminar`"
                            icon="TrashIcon" size="16" class="ml-1" @click="mostrarModalEliminar(row.item)"
                            v-b-tooltip.hover.top="'Eliminar Registro'" />
                    </div>
                </template>
                <template #cell(estado)="row">
                    <div class="text-nowrap">
                        <b-badge :variant="status[1][row.item.estado]" class="ml-1">
                            {{ status[0][row.item.estado] }}
                        </b-badge>
                    </div>
                </template>
            </b-table>
        </b-card>

        <b-modal id="modal-crear" ref="modal-crear" v-model="modalShowCrear" title="Crear Registro" ok-title="Crear"
            @show="resetModal" no-close-on-backdrop centered size="lg" @ok="okModalCrear">
            <div v-if="loadingCrear" align="center">
                <p>Editando registro ... </p>
                <b-spinner label="Loading..." variant="primary" />
            </div>
            <div v-else>
                <validation-observer ref="CrearResponsables">
                    <b-form autocomplete="off" @submit.prevent="CrearRegistro">
                        <b-row>
                            <b-col lg="4">
                                <label for="idcliente">Cliente</label>
                                <v-select id="idcliente" v-model="cliente" :options="clientes"
                                    :reduce="clientes => clientes.value" label="text" key="value"
                                    placeholder="Seleccionar..." class="select-size-sm mt-0">
                                    <span slot="no-options"> Sin datos</span>
                                </v-select>
                            </b-col>
                            <b-col lg="4">
                                <label for="idcultivo">Cultivo</label>
                                <v-select id="idcultivo" v-model="cultivo" :options="cultivos"
                                    :reduce="cultivos => cultivos.value" label="text" key="value"
                                    placeholder="Seleccionar..." class="select-size-sm mt-0">
                                    <span slot="no-options"> Sin datos</span>
                                </v-select>
                            </b-col>
                            <b-col lg="4">
                                <b-form-group label="Estado" label-for="estado">
                                    <v-select id="estado" v-model="estado" :reduce="estados => estados.value" label="text"
                                        key="value" :options="estados" :clearable="false" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>

        <b-modal id="modal-editar" ref="modal-editar" v-model="modalShowEditar" title="Editar Registro" ok-title="Editar"
            cancel-title="Cerrar" :cancel-disabled="loadingEditar" :ok-disabled="loadingEditar" no-close-on-esc
            no-close-on-backdrop centered size="lg" @ok="okModalEditar">
            <div v-if="loadingEditar" align="center">
                <p>Editando registro ... </p>
                <b-spinner label="Loading..." variant="primary" />
            </div>
            <div v-else>
                <validation-observer ref="editarResponsables">
                    <b-form autocomplete="off" @submit.prevent="EditarRegistro">
                        <b-row>
                            <b-col lg="4">
                                <label for="idcliente">Cliente</label>
                                <v-select id="idcliente" v-model="cliente" :options="clientes"
                                    :reduce="clientes => clientes.value" label="text" key="value"
                                    placeholder="Seleccionar..." class="select-size-sm mt-0">
                                    <span slot="no-options"> Sin datos</span>
                                </v-select>
                            </b-col>
                            <b-col lg="4">
                                <label for="idcultivo">Cultivo</label>
                                <v-select id="idcultivo" v-model="cultivo" :options="cultivos"
                                    :reduce="cultivos => cultivos.value" label="text" key="value"
                                    placeholder="Seleccionar..." class="select-size-sm mt-0">
                                    <span slot="no-options"> Sin datos</span>
                                </v-select>
                            </b-col>
                            <b-col lg="4">
                                <b-form-group label="Estado" label-for="estado">
                                    <v-select id="estado" v-model="estado" :reduce="estados => estados.value" label="text"
                                        key="value" :options="estados" :clearable="false" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </div>
        </b-modal>
    </div>
</template>
<script>
//import axiosIns from '@/libs/axios'
import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'

import {
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BModal,
    BPagination,
    BSpinner,
    BTable,
    BRow,
    BCol,
    BFormTimepicker,
    BDropdownDivider,
    BInputGroup, BInputGroupAppend, BTooltip,
    BFormCheckbox,
    BDropdown, BDropdownForm, BDropdownItem, BDropdownHeader,
    VBTooltip
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import moment from 'moment'

export default {
    components: {
        BCard,
        BFormTimepicker,
        BCardBody,
        BTable,
        BSpinner,
        BBadge,
        BFormGroup,
        BFormSelect,
        BPagination,
        BButton,
        BFormInput,
        BModal,
        BForm,
        BCol,
        BRow,
        BDropdownDivider,
        BInputGroup,
        BInputGroupAppend,
        BTooltip,
        BFormCheckbox,
        BDropdown, BDropdownForm, BDropdownItem, BDropdownHeader,

        vSelect,

        ValidationProvider,
        ValidationObserver,
    },
    directives: {
        'b-tooltip': VBTooltip,
        Ripple,
    },
    mixins: [heightTransition],
    data: () => ({
        id_user: JSON.parse(localStorage.getItem('userData')),
        cliente: null,
        clientes: [],
        cultivo: null,
        cultivos: [],
        estado: null,
        estados: [],
        id_editar: null,

        filterOn: [],
        loading: false,
        loadingEditar: false,
        loadingCrear: false,
        loadingExp: false,
        filter: null,

        items: [],
        fields: [
            {
                key: 'editar',
                label: 'Acciones',
                thClass: 'py-0 alinear-medio',
                class: 'text-center',
                stickyColumn: true
            },
            {
                key: 'estado',
                label: 'Estado',
                thClass: 'py-0 alinear-medio',
                class: 'text-center',
                stickyColumn: true
            },
            {
                key: 'cliente',
                label: 'Ciente',
                sortable: true,
                tdClass: 'alinear-una-sola-linea',
                thClass: 'py-0 alinear-medio',
            },
            {
                key: 'cultivo',
                label: 'Cultivo',
                sortable: true,
                tdClass: 'alinear-una-sola-linea',
                thClass: 'py-0 alinear-medio',
            },
            {
                key: 'usuario',
                label: 'Registrado por',
                sortable: true,
                tdClass: 'alinear-una-sola-linea',
                thClass: 'py-0 alinear-medio',
            },
            {
                key: 'created',
                label: 'Fecha de Registro',
                sortable: true,
                tdClass: 'alinear-una-sola-linea',
                thClass: 'py-0 alinear-medio',
            },
        ],

        status: [
            {
                0: 'Activo',
                // 1: 'Inactivo',
                1: 'Cancelado',
                // 3: 'Eliminado',
            },
            {
                0: 'light-success',
                // 1: 'light-warning',
                1: 'light-danger',
                // 3: 'light-dark',
            }
        ],

        estados: [
            { value: '0', text: "Activo" },
            // { value: '1', text: "Siembra" },
            { value: '1', text: "Cancelado" },
            // { value: '3', text: "Eliminado" },
        ],

        modalShowEditar: false,
        modalShowCrear: false,

        required,
    }),

    mounted() {
        this.traerData();
        this.traerFiltros();
    },

    methods: {
        traerData() {
            const yo = this
            yo.loading = true
            const config = {
                method: 'get',
                url: '/comex/ParametrosEnvio/list/'
            }
            axiosIns(config)
                .then(function (response) {
                    if (response.status === 200) {
                        yo.items = response.data
                        yo.CambioFormatoFecha();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(function () {
                    yo.loading = false
                })

        },
        CambioFormatoFecha() {
            let yo = this;
            for (let value of yo.items) {
                if (value.created != null && value.created !== '' && value.created !== ' ' && value.created !== '  ') {
                    value.created = moment(String(value.created)).format('DD/MM/YYYY  HH:mm:ss')
                }
            }

        },
        okModalEditar(bvModalEvt) {
            bvModalEvt.preventDefault()
            this.EditarRegistro()
        },
        mostrarModalEditar(arrData) {
            const yo = this
            yo.modalShowEditar = true
            yo.id_editar = arrData.id
            yo.cliente = arrData.cliente
            yo.cultivo = arrData.cultivo
            yo.estado = arrData.estado
        },
        EditarRegistro() {
            const yo = this
            yo.$refs.editarResponsables.validate().then(success => {
                if (success) {
                    yo.loadingEditar = true
                    const data = JSON.stringify({
                        'cliente': yo.cliente,
                        'cultivo': yo.cultivo,
                        'usuario': yo.id_user.username,
                        'estado': yo.estado,
                    })
                    // AQUI
                    const config = {
                        method: 'put',
                        url: 'comex/ParametrosEnvio/update/' + yo.id_editar,
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        data: data
                    }
                    axiosIns(config).then(function (response) {
                        if (response.status === 200) {
                            yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se editó correctamente.", 'success', 5000)
                        }
                    })
                        .catch(function (error) {
                            console.log(error);
                            yo.mostrarNotificacion('Error en la edición.', 'BellIcon', error.toString(), 'danger', 5000)
                        })
                        .finally(function () {
                            yo.traerData()
                            yo.$nextTick(() => {
                                yo.$refs['modal-editar'].toggle('#toggle-btn')
                            })
                            yo.loadingEditar = false
                        })

                }
            })
        },

        okModalCrear(bvModalEvt) {
            bvModalEvt.preventDefault()
            this.CrearRegistro()
        },

        CrearRegistro() {
            const yo = this
            this.$refs.CrearResponsables.validate().then(success => {
                if (success) {
                    yo.modalShowCrear = true

                    const data = JSON.stringify({
                        'cliente': yo.cliente,
                        'cultivo': yo.cultivo,
                        'usuario': yo.id_user.username,
                        'estado': yo.estado,
                    })
                    const config = {
                        method: 'post',
                        url: 'comex/ParametrosEnvio/create/',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        data: data
                    }
                    axiosIns(config).then(function (response) {
                        if (response.status === 201) {
                            yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "El registro se realizó correctamente.", 'success', 5000)
                        }
                    })
                        .catch(function (error) {
                            console.log(error);
                            yo.mostrarNotificacion('Error en el registro del Usuario.', 'BellIcon', error.toString(), 'danger', 5000)
                        })
                        .finally(function () {
                            yo.traerData()
                            yo.$nextTick(() => {
                                yo.$refs['modal-crear'].toggle('#toggle-btn')
                            })
                            yo.loadingEditar = false
                        })

                }
            })
        },
        mostrarModalVaciar() {
            const yo = this
            yo.$swal({
                title: '¿Estás seguro que desea Eliminar toda la Data?',
                text: "Una vez ejecutado, No podrás revertir esta acción",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {



                    const config = {
                        method: 'get',
                        url: '/comex/ParametrosEnvio/destroyall/'
                    }
                    axiosIns(config)
                        .then(response => {
                            console.log(response.status)
                            if (response.status === 200) {
                                this.$toast({
                                    component: ToastificationContent,
                                    props: {
                                        title: "ELIMINADO",
                                        icon: "TrashIcon",
                                        text: "Se Eliminaron correctamente todos Registros",
                                        variant: "danger",
                                    }
                                },
                                    {
                                        timeout: 5000,
                                        position: 'top-center',
                                    })
                            } else {
                                yo.mostrarNotificacion('Error!', 'CheckIcon', "Error en el servidor.", 'danger', 5000)
                            }
                            yo.traerData()
                        })
                        .catch(error => {
                            yo.mostrarNotificacion('Error!', 'CheckIcon', "Ocurrio un error al intentar eliminar los registros.", 'warning', 5000)
                        });
                }
            })
        },
        sendMails() {
            const yo = this
            yo.$swal({
                title: '¿Estás seguro que desea enviar los correos los clientes?',
                text: "Una vez ejecutado, No podrás revertir esta acción",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    yo.$swal({
                        title: 'Enviando correos',
                        html:
                            '<div class="container">' +
                            '<div class="row mt-1">' +
                            '<div class="col-12 text-center">' +
                            '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="upload" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-upload" style="width: 50px; height: 50px;"><path fill="currentColor" d="M105.4 182.6c12.5 12.49 32.76 12.5 45.25 .001L224 109.3V352c0 17.67 14.33 32 32 32c17.67 0 32-14.33 32-32V109.3l73.38 73.38c12.49 12.49 32.75 12.49 45.25-.001c12.49-12.49 12.49-32.75 0-45.25l-128-128C272.4 3.125 264.2 0 256 0S239.6 3.125 233.4 9.375L105.4 137.4C92.88 149.9 92.88 170.1 105.4 182.6zM480 352h-160c0 35.35-28.65 64-64 64s-64-28.65-64-64H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456z" class=""></path></svg>' +
                            "</div>" +
                            "</div>" +
                            '<div class="row mt-2 mb-1">' +
                            '<div class="col-12 text-center">' +
                            '<p class="mb-0"> No cierre esta ventana hasta que termine el proceso de envio de correos...' +
                            "</p>" +
                            "</div>" +
                            "</div>" +
                            "</div>",
                        text: "",
                        showConfirmButton: false,
                        timerProgressBar: true,
                        allowOutsideClick: false
                    })
                    const config = {
                        method: 'get',
                        url: '/comex/emails_enviar_auth/'
                    }
                    axiosIns(config)
                        .then(response => {
                            if (response.status === 200) {
                                this.$toast({
                                    component: ToastificationContent,
                                    props: {
                                        title: "ENVIADO",
                                        icon: "SendIcon",
                                        text: "Se enviaron correctamente todos correos",
                                        variant: "success",
                                    }
                                },
                                    {
                                        timeout: 5000,
                                        position: 'top-center',
                                    })
                            } else {
                                yo.mostrarNotificacion('Error!', 'CheckIcon', "Error en el servidor.", 'danger', 5000)
                            }
                        }).finally(f => {
                            yo.$swal.close();
                        }).catch(error => {
                            console.log(error)
                            yo.mostrarNotificacion('Error!', 'CheckIcon', "Ocurrio un error al intentar enviar los correos.", 'warning', 5000)
                        });
                }
            })
        },
        mostrarModalEliminar(arrData) {
            const yo = this
            yo.$swal({
                title: '¿Estás seguro que desea Eliminar?',
                text: "Una vez ejecutado, No podrás revertir esta acción",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí',
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    const config = {
                        method: 'delete',
                        url: '/comex/ParametrosEnvio/destroy/' + arrData.id,
                    }
                    axiosIns(config)
                        .then(response => {
                            if (response.status === 204) {
                                this.$toast({
                                    component: ToastificationContent,
                                    props: {
                                        title: "ELIMINADO",
                                        icon: "TrashIcon",
                                        text: "Se Elimino correctamente el Registro",
                                        variant: "danger",
                                    }
                                },
                                    {
                                        timeout: 5000,
                                        position: 'top-center',
                                    })
                            } else {
                                yo.mostrarNotificacion('Error!', 'CheckIcon', "Error en el servidor.", 'danger', 5000)
                            }
                            yo.traerData()
                        })
                        .catch(error => {
                            yo.mostrarNotificacion('Error!', 'CheckIcon', "Ocurrio un error al intentar eliminar el registro.", 'warning', 5000)
                        });
                }
            })
        },

        mostrarNotificacion(titulo, icono, texto, variante, tiempo) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: titulo,
                    icon: icono,
                    text: texto,
                    variant: variante
                }
            },
                {
                    timeout: tiempo,
                    position: 'top-center',
                })
        },

        resetModal() {
            this.cliente = null,
                this.cultivo = null,
                this.estado = '0'
        },

        traerFiltros() {
            let yo = this;
            yo.clientes = [];
            yo.cultivos = [];
            const config = {
                method: 'get',
                url: '/comex/filtros_shipping/'
            }
            axiosIns(config)
                .then(function (response) {
                    if (response.status === 200) {
                        for (let value of response.data['Clientes']) {
                            if (value.customer != null && value.customer !== '' && value.customer !== ' ' && value.customer !== '  ') {
                                yo.clientes.push({ value: value.customer, text: value.customer })
                            }
                        }
                        for (let value of response.data['Cultivos']) {
                            if (value.cultivo != null && value.cultivo !== '' && value.cultivo !== ' ' && value.cultivo !== '  ') {
                                yo.cultivos.push({ value: value.cultivo, text: value.cultivo })
                            }
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(function () {
                    yo.loading = false
                    yo.filtrando = false
                })


        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.alinear-una-sola-linea {
    white-space: nowrap !important;
}

.alinear-medio {
    vertical-align: middle !important;
}
</style>
